// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as FareEstimateResultOmsApiModel$PorterinFeature from "../api-model/FareEstimateResultOmsApiModel.mjs";

function apiModelToState(model) {
  return {
          vehicles: $$Array.map((function (vehicle) {
                  return {
                          name: vehicle.display_name,
                          vehicle_id: vehicle.vehicle_id,
                          vehicle_type: vehicle.vehicle_type,
                          capacity_display: vehicle.capacity_display,
                          dimensions: vehicle.size_display,
                          fare: vehicle.base_fare_display,
                          base_fare: vehicle.base_fare.value
                        };
                }), Js_array.filter((function (vehicle) {
                      return Js_string.includes("Helper", vehicle.vehicle_type) === false;
                    }), model.vehicles)),
          request_id: model.callback_request_response.callback_request_id,
          lead_entry_created: Belt_Option.getWithDefault(model.callback_request_response.lead_entry_created, false)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(FareEstimateResultOmsApiModel$PorterinFeature.t_decode(json), "FareEstimateResultOmsEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
